angular.module('aprima-legacy-common').factory('debugLogService',[function( ){
'use strict';
var debugMode = false;
return {
               disableDebugMode : function () {
                    debugMode = false;  
                },
                enableDebugMode : function(){
                    debugMode = true;
                },
                getDebugMode : function() {
                    return debugMode;
                 }
                 

};
        }]);